/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M21 3L17 3M21 3L21 7M21 3L17 7L15 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 21V17M3 21H7M3 21L9 15M3 3V7M3 3H7M3 3L9 9M21 21H17M21 21V17M21 21L15 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="3"
				y="3"
				width="18"
				height="18"
				fill="currentColor"
			/>
			<path
				d="M3 21V17M3 21H7M3 21L9 15M21 3H17M21 3V7M21 3L15 9M3 3V7M3 3H7M3 3L9 9M21 21H17M21 21V17M21 21L15 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 21V17M3 21H7M3 21L9 15M21 3H17M21 3V7M21 3L15 9M3 3V7M3 3H7M3 3L9 9M21 21H17M21 21V17M21 21L15 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7 21H3L9 15M17 3H21L15 9M21 6V7.5M3 18V16.5M3 7V3L9 9M21 17V21L15 15M18 21H16.5M6 3H7.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 21V17M3 21H7M3 21L9 15M21 3H17M21 3V7M21 3L15 9M3 3V7M3 3H7M3 3L9 9M21 21H17M21 21V17M21 21L15 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 21V17M3 21H7M3 21L9 15M21 3H17M21 3V7M21 3L15 9M3 3V7M3 3H7M3 3L9 9M21 21H17M21 21V17M21 21L15 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
